var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer justify-center",class:_vm.classes},[(_vm.roleIsMerchant)?_c('feedback-button',{staticClass:"mx-4"}):_vm._e(),(_vm.roleIsMerchant)?_c('contact-button',{staticClass:"mx-4"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }